import { render, staticRenderFns } from "./AMisRendererComent.vue?vue&type=template&id=630fbff2&scoped=true"
import script from "./AMisRendererComent.vue?vue&type=script&lang=js"
export * from "./AMisRendererComent.vue?vue&type=script&lang=js"
import style0 from "./AMisRendererComent.vue?vue&type=style&index=0&id=630fbff2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630fbff2",
  null
  
)

export default component.exports